import React from 'react'
import ColliderBox from './Collider'
// import { space1WallData } from './wallData'

const s = 1

const Walls = ({ wallData }) => {
    return (
        <>
            {wallData.map((wall) => {
                return <ColliderBox trigger={wall.trigger} size={[wall.size[0] * s, wall.size[1] * s, wall.size[2] * s]} rotation={[0, 0, 0]} position={[wall.position[0] * s, wall.position[1] * s, wall.position[2] * s]} />
            })}
        </>
    )
}

export default Walls
